import { MenuItem } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { env } from '@/shared/config'
import { useI18n } from '@/shared/lib/i18n'

import { NavbarItem } from '../navbar-item/view'
import { navbarMenu } from '../styles/recipe'
import type { NavbarItemVariant } from '../types'

export function KnowledgeLink({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const { i18n } = useI18n()
    const classes = navbarMenu()

    if (variant === 'dropdown') {
        return (
            <MenuItem
                className={cx(classes.itemNav, css({ textTransform: 'uppercase' }))}
                href={env.ZENDESK_PAGE_URL}
                target="_blank"
                rel="noreferrer"
            >
                <i id="icon-book" className={cx('fa-light fa-book', classes.icon)} />
                &nbsp;{i18n.PORTAL_KNOWLEDGE_BASE}
            </MenuItem>
        )
    }

    return (
        <NavbarItem
            navbarItemType="link"
            href={env.ZENDESK_PAGE_URL}
            styles={css.raw({ display: { base: 'none', lg: 'flex' } })}
        >
            {i18n.PORTAL_KNOWLEDGE_BASE}
        </NavbarItem>
    )
}
